export default __webpack_public_path__ + "static/media/logo3.b20a7a3c.png";